import { Navigate, Outlet, useSearchParams } from "react-router-dom"
import { Spinner } from "@/components/ui/spinner"
import { useAuth } from "@/contexts/AuthContext"

// Kebalikan ProtectedRoute: user yang SUDAH login dilempar keluar dari
// halaman login/register (ke tujuan ?redirect= kalau ada, selain itu ke beranda)
export function GuestRoute() {
  const { isAuthenticated, isLoading, user } = useAuth()
  const [searchParams] = useSearchParams()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="size-8 text-primary" />
      </div>
    )
  }

  if (isAuthenticated) {
    const redirect = searchParams.get("redirect")
    const fallback = user?.role === "administrator" ? "/admin" : "/"
    return <Navigate to={redirect && redirect.startsWith("/") ? redirect : fallback} replace />
  }

  return <Outlet />
}
